// src/components/ShelfChanger.js

import React from "react";
import PropTypes from "prop-types";

const ShelfChanger = ({ book, changeBookShelf }) => {
    const currentShelf = book.shelf ? book.shelf : "none";

    return (
        <select
            value={currentShelf} 
            onChange={(e) => changeBookShelf(book, e.target.value)}
            aria-label="Book Shelf Selector"
        >
            <option value="move" disabled>
                Move to...
            </option>
            <option value="currentlyReading">Currently Reading</option>
            <option value="wantToRead">Want to Read</option>
            <option value="read">Read</option>
            <option value="none">None</option>
        </select>
    );
};

ShelfChanger.propTypes = {
    book: PropTypes.shape({
        id: PropTypes.string.isRequired,
        shelf: PropTypes.string,
    }).isRequired,
    changeBookShelf: PropTypes.func.isRequired,
};

export default ShelfChanger;